import { render, staticRenderFns } from "./Entrepreneurs.vue?vue&type=template&id=39c324a4&"
import script from "./Entrepreneurs.vue?vue&type=script&lang=js&"
export * from "./Entrepreneurs.vue?vue&type=script&lang=js&"
import style0 from "./Entrepreneurs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports